import { Component, Input, OnInit } from '@angular/core';

import { Property, PropertySet } from '@mirage-projects/cw-models';
import { DbPcvizService, UtilsPcvizService } from '@mirage-projects/cw-pcviz-core';
import { NumberHelperService } from '@mirage-projects/cw-utils';

import { PropertyBagService } from '../property-bag.service';

type NativeType = 'string' | 'number' | 'bigint' | 'boolean' | 'symbol' | 'undefined' | 'object' | 'function';
type InputType = 'text' | 'number';

/** This component is responsible to show point property */
@Component({
    selector: 'cw-property-point',
    templateUrl: './property-point.component.html',
    styleUrls: ['./property-point.component.scss'],
    standalone: false,
})
export class PropertyPointComponent implements OnInit {
    /** This object comes from the core and provides methods to obtain and set the value of the properties */
    @Input() propertySet!: PropertySet;
    /** Input field with the required information for this field type */
    @Input() property!: Property;

    nativeType!: NativeType;
    inputType: InputType = 'number';
    label = '';

    constructor(
        private propertyBagService: PropertyBagService,
        private dbPcvizService: DbPcvizService,
        private utilsPcvizService: UtilsPcvizService,
        private numberHelperService: NumberHelperService
    ) {}

    ngOnInit(): void {
        this.label = this.propertyBagService.getCorrectLabel(this.property);
        this.registerListeners();
    }

    getValueName(property: Property, index: number): string {
        if (property.field !== 'position' && property.field !== 'point') {
            return this.utilsPcvizService.getCRSUtils().defaultCoordName(index);
        }

        // Select coordinate labels depending on project CRS
        const project = this.dbPcvizService.getControllerDB('Application').getApplication().getProject();
        const projection = project.getProjection();
        return this.utilsPcvizService.getCRSUtils().getCoordLabel(projection, index);
    }

    onChange(i: number): void {
        this.property.value[i] = parseFloat(this.property.value[i]);

        this.propertyBagService.setValueProperty(this.propertySet, this.property);
    }

    get value(): any {
        this.property.value = this.propertyBagService.getValueProperty(this.propertySet, this.property);

        this.nativeType = typeof this.property.value[0];

        // TODO: Review this code. When is text type and editable doesn't work fine. At the moment we just use number type
        // this.inputType = this.property.editable() && this.nativeType === 'number' ? 'number' : 'text';
        // this.inputType = 'number';
        const decimals = this.dbPcvizService
            .getControllerDB('UserPreferences')
            .getPreference(this.dbPcvizService.getUtils().NUMBER_OF_DECIMALS_KEY);

        this.applyDecimals(decimals);
        return this.property.value;
    }

    private registerListeners(): void {
        this.dbPcvizService
            .getControllerDB('UserPreferences')
            .registerListener(
                this.dbPcvizService.getListenerController().PROJECT,
                this.dbPcvizService.getUtils().NUMBER_OF_DECIMALS_KEY,
                (numberDecimals: number) => {
                    this.applyDecimals(numberDecimals);
                }
            );
    }

    private applyDecimals(decimals: number): void {
        if (this.nativeType === 'number') {
            this.property.value.forEach((n: number, index: number) => {
                if (index <= 2) {
                    const formatedValue = this.numberHelperService.toFixedWithPrecision(n, decimals);
                    this.property.value[index] = parseFloat(formatedValue);
                }
            });
        }
    }
}
